import React from 'react'

export const QuestionIcon: React.FC = () => (
  <svg viewBox='0 0 34 34' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M16.9999 31.1666C24.824 31.1666 31.1666 24.824 31.1666 16.9999C31.1666 9.17588 24.824 2.83325 16.9999 2.83325C9.17588 2.83325 2.83325 9.17588 2.83325 16.9999C2.83325 24.824 9.17588 31.1666 16.9999 31.1666Z'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M12.8774 12.7501C13.2105 11.8033 13.8679 11.0049 14.7332 10.4963C15.5985 9.9878 16.6159 9.8019 17.6051 9.97158C18.5943 10.1413 19.4916 10.6556 20.138 11.4234C20.7843 12.1912 21.1381 13.1631 21.1366 14.1667C21.1366 17.0001 16.8866 18.4167 16.8866 18.4167'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M17 24.0833H17.0146'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)
